module.exports = __webpack_public_path__ + "a4d348a7358cf2a46be4ef7c60700c3f.jpg";